import React, { useEffect } from "react"
import {
  SelectChangeEvent,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Checkbox,
  Box,
} from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { UploadStatus } from "../../constants/data"
import { RefreshRounded } from "@mui/icons-material"
import {
  PrimaryButton,
  StyledButton,
  StyledFormControl,
} from "../Transactions/styles"
import {
  selectUploadHistory,
  setFilters,
} from "../../slices/uploadHistorySlice"
import { getBankList, selectTransactions } from "../../slices/transactionsSlice"
interface UploadHistoryFiltersProps {
  resetFilterHandler: () => void
  ApplyFilterHandler: () => void
}

const UploadHistoryFilters: React.FC<UploadHistoryFiltersProps> = ({
  resetFilterHandler,
  ApplyFilterHandler,
}) => {
  const { filters } = useAppSelector(selectUploadHistory)
  const dispatch = useAppDispatch()

  const { bankList, isBankListLoading } = useAppSelector(selectTransactions)

  useEffect(() => {
    dispatch(getBankList())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Stack direction="column" gap={2}>
      <StyledFormControl size="small">
        <InputLabel id="select-accounts">Account</InputLabel>
        <Select
          labelId="select-accounts"
          id="selectAccounts"
          label="Account"
          multiple
          value={filters.bankAccountId || []}
          onChange={(e: SelectChangeEvent<string[]>) =>
            dispatch(
              setFilters({
                ...filters,
                bankAccountId:
                  typeof e.target.value === "string"
                    ? [e.target.value]
                    : e.target.value,
              }),
            )
          }
          renderValue={(selected) => {
            const selectedAccounts = bankList?.filter((option) =>
              selected.includes(option.id),
            )
            return selectedAccounts
              .map((account) => account.accountName)
              .join(", ")
          }}
          disabled={isBankListLoading}
        >
          {isBankListLoading ? (
            <MenuItem value="">Loading...</MenuItem>
          ) : (
            bankList?.map((bank) => (
              <MenuItem key={bank.id} value={bank.id}>
                <Checkbox
                  checked={
                    filters.bankAccountId &&
                    filters.bankAccountId.includes(bank.id)
                  }
                />
                {bank.accountName}
              </MenuItem>
            ))
          )}
        </Select>
      </StyledFormControl>
      <StyledFormControl size="small">
        <InputLabel id="marked-status-select">Status</InputLabel>
        <Select
          labelId="marked-status-select"
          id="isMarked"
          value={filters.status}
          label="Status"
          onChange={(e: SelectChangeEvent) =>
            dispatch(
              setFilters({
                ...filters,
                status: e.target.value as string,
              }),
            )
          }
        >
          <MenuItem value={UploadStatus.PROCESSING}>Processing</MenuItem>
          <MenuItem value={UploadStatus.SUCCESS}>Success</MenuItem>
          <MenuItem value={UploadStatus.FAILED}>Failed</MenuItem>
          <MenuItem value={UploadStatus.RECONCILED}>Reconciled</MenuItem>
        </Select>
      </StyledFormControl>

      <Box sx={{ display: "flex", gap: "10px", flex: 1 }}>
        <StyledButton
          sx={{ width: "100%" }}
          variant="outlined"
          startIcon={<RefreshRounded fontSize="small" />}
          color="inherit"
          onClick={resetFilterHandler}
        >
          Reset
        </StyledButton>
        <PrimaryButton
          sx={{ width: "100%" }}
          variant="contained"
          onClick={ApplyFilterHandler}
        >
          Apply
        </PrimaryButton>
      </Box>
    </Stack>
  )
}

export default UploadHistoryFilters
